import { clientAddressConstant } from "../_constants"
import { clientService } from "../_services/clientAddress.service";
import { alert } from "../_utilities/alert";

export const clientAction = {
    createClientAddress
}

function createClientAddress(data) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: clientAddressConstant.CREATE_CLIENT_ADDRESS_REQUEST,
                data: null
            })
        );
        clientService
            .createClientAddress({...data})
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: clientAddressConstant.CREATE_CLIENT_ADDRESS_SUCCESS,
                                data: response.Result,
                            })
                        );
                        alert.success(response.Message)
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: clientAddressConstant.CREATE_CLIENT_ADDRESS_FAILURE,
                                data: null
                            })
                        )
                        alert.error(response.Message)
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: clientAddressConstant.CREATE_CLIENT_ADDRESS_FAILURE,
                            data: error
                        })
                    )
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
            })
    }
}


function dispatchFunction(data) {
    return {
        type: data.type,
        data: data.data
    }
}